// @ts-nocheck

import { useState, useEffect } from "react";

// react-router components
import { useLocation, useNavigate } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import Avatar from "@mui/material/Avatar";
import Icon from "@mui/material/Icon";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
// Soft UI Dashboard React components
import SoftBox from "../../common/softBox";
import SoftTypography from "../../common/softTypography";
// Soft UI Dashboard React examples
import Breadcrumbs from "../../breadcrumbs";
import NotificationItem from "../../items/notificationItem";
import LogoutIcon from "@mui/icons-material/Logout";
// import PaymentIcon from "@mui/icons-material/Payment";
// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarMobileMenu,
} from "./styles";

// Soft UI Dashboard React context
import {
  useSoftUIController,
  setTransparentNavbar,
  setMiniSidenav,
  // setOpenConfigurator,
} from "../../../context";

// Images
// import team2 from "../../../assets/images/team-2.jpg";
// import logoSpotify from "../../../assets/images/small-logos/logo-spotify.svg";
import {
  getNotifications,
  markNotificationRead,
} from "../../../features/notification";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../Hooks";
import {
  FaBell,
  FaShoppingCart,
  FaThumbsUp,
  FaEnvelopeOpenText,
  FaNewspaper,
  FaBullhorn,
  FaComments,
  FaUserShield,
  FaFileContract,
  FaUndoAlt,
  FaClock,
} from "react-icons/fa";
import SoftBadge from "../../common/softBadge";
import { IoIosNotificationsOutline } from "react-icons/io";

function DashboardNavbar({ absolute = false, light = false, isMini = false }) {
  const getNotificationIcon = (type: number) => {
    // // // console.log(type, "type");
    // // // console.log(typeof type, "typeof type");

    switch (type) {
      case 1:
        return <FaShoppingCart className="text-xl text-blue-500" style={{ color: 'white' }} />; // order
      case 2:
        return <FaThumbsUp className="text-xl text-green-500" style={{ color: 'white' }} />; // credit limit approve
      case 3:
        return <FaEnvelopeOpenText className="text-xl text-indigo-500" style={{ color: 'white' }} />; // contact us reply
      case 4:
        return <FaNewspaper className="text-xl text-purple-500" style={{ color: 'white' }} />; // create publication
      case 5:
        return <FaBullhorn className="text-xl text-pink-500" style={{ color: 'white' }} />; // create promotion
      case 6:
        return <FaComments className="text-xl text-cyan-500" style={{ color: 'white' }} />; // chat
      case 7:
        return <FaUserShield className="text-xl text-yellow-500" style={{ color: 'white' }} />; // privacy update
      case 8:
        return <FaFileContract className="text-xl text-orange-500" style={{ color: 'white' }} />; // terms update
      case 9:
        return <FaUndoAlt className="text-xl text-red-500" style={{ color: 'white' }} />; // sales order return
      case 10:
        return <FaClock className="text-xl text-gray-500" style={{ color: 'white' }} />; // expire order return
      case 0:
      default:
        return <FaBell className="text-xl text-gray-400" style={{ color: 'white' }} />; // other / default
    }
  };

  const navigate = useNavigate();
  const route = useLocation().pathname.split("/").slice(1);
  const [controller, uiDispatch] = useSoftUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar } = controller;
  const [navbarType, setNavbarType] = useState();
  const [openMenu, setOpenMenu] = useState(false);
  const [openProfile, setOpenProfile] = useState(null);
  const dispatch = useAppDispatch();

  let currentUser: any = {};
  try {
    currentUser = JSON.parse(localStorage.getItem("user") || "{}");
  } catch (error) {
    currentUser = {};
  }
  const displayName = currentUser?.name || currentUser?.email || "Admin";
  const displayEmail = currentUser?.email || "";
  const avatarInitial = (displayName || "A").trim().charAt(0).toUpperCase();

  const { notifications } = useSelector((state: any) => state.notification);
  // // // console.log(notifications, "notifications");
  useEffect(() => {
    dispatch(getNotifications());
  }, [dispatch]);

  useEffect(() => {
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    function handleTransparentNavbar() {
      setTransparentNavbar(
        uiDispatch,
        (fixedNavbar && window.scrollY === 0) || !fixedNavbar
      );
    }

    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [uiDispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(uiDispatch, !miniSidenav);
  // const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleReadNotifivation = (notification: any) => {
    // console.log({ notification })
    if (notification.type === "6") {
      navigate(`/customer-support/${notification.sender_id}`);
    }

    dispatch(markNotificationRead(notification._id));
    // setOpenMenu(false);
  };
  const handleCloseMenu = (id: string) => {
    setOpenMenu(false);
  };

  const handleOpenProfile = (event) => setOpenProfile(event.currentTarget);
  const handleCloseProfile = () => setOpenProfile(null);

  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      PaperProps={{
        sx: {
          mt: 1.5,
          minWidth: 320,
          maxWidth: 380,
          maxHeight: 440,
          borderRadius: "12px",
          boxShadow: "0 12px 32px -4px rgba(20, 20, 40, 0.18)",
          overflow: "hidden",
        },
      }}
    >
      <SoftBox px={2} py={1.5} display="flex" alignItems="center" justifyContent="space-between">
        <SoftTypography variant="button" fontWeight="bold" textTransform="uppercase" color="dark">
          Notifications
        </SoftTypography>
        {notifications && notifications.length > 0 && (
          <SoftTypography variant="caption" color="text">
            {notifications.length} new
          </SoftTypography>
        )}
      </SoftBox>
      <Divider sx={{ my: 0 }} />
      {notifications &&
        notifications.length > 0 &&
        notifications.map((notification, index) => (
          <NotificationItem
            key={index}
            image={getNotificationIcon(Number(notification.type))}
            title={[ notification.title, notification.message]}
            date={new Date(notification.created_at).toLocaleString()}
            onClick={() => handleReadNotifivation(notification)}
          />
        ))}
      {(!notifications || notifications.length === 0) && (
        <SoftBox px={2} py={3} textAlign="center">
          <SoftTypography variant="caption" color="text">
            No notifications yet
          </SoftTypography>
        </SoftBox>
      )}
    </Menu>
  );

  const renderProfileMenu = () => (
    <Menu
      anchorEl={openProfile}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={Boolean(openProfile)}
      onClose={handleCloseProfile}
      PaperProps={{
        sx: {
          mt: 1.5,
          minWidth: 240,
          borderRadius: "12px",
          boxShadow: "0 12px 32px -4px rgba(20, 20, 40, 0.18)",
          overflow: "hidden",
        },
      }}
    >
      <SoftBox px={2} py={1.5} display="flex" alignItems="center">
        <Avatar
          sx={{
            width: 40,
            height: 40,
            bgcolor: "#344767",
            fontWeight: 600,
            fontSize: "1rem",
          }}
        >
          {avatarInitial}
        </Avatar>
        <SoftBox ml={1.5} lineHeight={1.2}>
          <SoftTypography variant="button" fontWeight="bold" display="block" color="dark">
            {displayName}
          </SoftTypography>
          {displayEmail && (
            <SoftTypography variant="caption" color="text">
              {displayEmail}
            </SoftTypography>
          )}
        </SoftBox>
      </SoftBox>
      <Divider sx={{ my: 0 }} />
      <MenuItem
        onClick={handleLogout}
        sx={{ py: 1.25, gap: 1.5, fontSize: "0.85rem", color: "#344767" }}
      >
        <LogoutIcon fontSize="small" />
        Logout
      </MenuItem>
    </Menu>
  );

  const handleLogout = () => {
    localStorage.clear();
    navigate("/sign-in");
  };

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        <SoftBox
          color="inherit"
          mb={{ xs: 1, md: 0 }}
          sx={(theme) => navbarRow(theme, { isMini })}
        >
          <Breadcrumbs
            icon="home"
            title={route[route.length - 1]}
            route={route}
            light={light}
          />
        </SoftBox>
        {isMini ? null : (
          <SoftBox sx={(theme) => navbarRow(theme, { isMini })}>
            {/* <SoftBox pr={1}>
              <SoftInput

                placeholder="Type here..."
                icon={{ component: "search", direction: "left" }}
              />
            </SoftBox> */}

            <SoftBox color={light ? "white" : "inherit"}>
              <IconButton
                size="small"
                color="inherit"
                sx={navbarMobileMenu}
                onClick={handleMiniSidenav}
              >
                <Icon className={light ? "text-white" : "text-dark"}>
                  {miniSidenav ? <MenuOpenIcon /> : <MenuOpenIcon />}
                </Icon>
              </IconButton>
              <IconButton
                size="small"
                color="inherit"
                sx={navbarIconButton}
                aria-controls="notification-menu"
                aria-haspopup="true"
                variant="contained"
                onClick={handleOpenMenu}
              >
                {/* <Icon className={light ? "text-white" : "text-dark"}>notifications</Icon> */}
                <SoftBadge color="success" variant="gradient" badgeContent={notifications.length} size="xs" >
                  <IoIosNotificationsOutline
                    size={20}
                    className={light ? "text-white" : "text-dark"}
                  />
                </SoftBadge>
              </IconButton>
              <IconButton
                size="small"
                color="inherit"
                sx={{ ...navbarIconButton, ml: 1 }}
                aria-controls="profile-menu"
                aria-haspopup="true"
                onClick={handleOpenProfile}
              >
                <Avatar
                  sx={{
                    width: 34,
                    height: 34,
                    bgcolor: "#344767",
                    color: "#fff",
                    fontWeight: 600,
                    fontSize: "0.85rem",
                  }}
                >
                  {avatarInitial}
                </Avatar>
              </IconButton>

              {renderMenu()}
              {renderProfileMenu()}
            </SoftBox>
          </SoftBox>
        )}
      </Toolbar>
    </AppBar>
  );
}

DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
